import React, { CSSProperties } from 'react';
import Price from '@/components/Price';
import BigNumber from 'bignumber.js';

type Props = {
  actualPrice: BigNumber;
  cashReceived: BigNumber;
};

const style = {
  fontSize: 16,
  textAlign: 'center',
  fontWeight: 'normal',
} as CSSProperties;

const CashCalc: React.FC<Props> = ({ cashReceived, actualPrice }: Props) => {
  const compared = cashReceived.comparedTo(actualPrice);

  if (compared > 0) {
    return (
      <div style={style}>
        请找零:{' '}
        <Price
          type={'green'}
          value={cashReceived.minus(actualPrice)}
          valueStyle={{ fontSize: 20 }}
        />{' '}
        元
      </div>
    );
  } else if (compared < 0) {
    return (
      <div style={style}>
        还需支付: <Price value={actualPrice.minus(cashReceived)} valueStyle={{ fontSize: 20 }} /> 元
      </div>
    );
  }
  return <div style={style}>无需找零</div>;
};

export default CashCalc;
